import { combineReducers } from 'redux'

import invoice from './invoice'
import user from './user'
import theme from './theme'
import notifications from './notifications'
import api from './api'
import school from './school'

export default combineReducers({
  api,
  invoice,
  user,
  theme,
  notifications,
  school,
})
